var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form"]
var hoisted2 = ["class", "form-group"]
var hoisted3 = ["for", "name"]
var hoisted4 = ["type", "text", "id", "name", "class", "form-control", "focus", "true", "required", ""]
var hoisted5 = ["class", "form-group"]
var hoisted6 = ["for", "description"]
var hoisted7 = ["id", "description", "class", "form-control input-sm"]
var hoisted8 = ["type", "button", "class", "btn btn-primary btn-xs"]
var hoisted9 = ["class", "fa fa-plus"]
var __target

module.exports = function description (model, root) {
  elementOpen("form", "b89d1bdb-2c77-4082-8dbe-c12ee506c510", hoisted1)
    elementOpen("div", "47af7fbf-d01f-48a8-90fb-b12570a670d1", hoisted2)
      elementOpen("label", "d03e3655-0af6-40e2-a163-28364781a814", hoisted3)
        text("Model Name")
      elementClose("label")
      elementOpen("input", "86865faf-c602-4f04-bb1b-563969ac06a9", hoisted4, "value", model.name, "onchange", function ($event) {
        var $element = this;
      model.name = this.value})
      elementClose("input")
    elementClose("div")
    elementOpen("div", "5dec7632-fe20-48d7-8374-ff24b5837552", hoisted5)
      elementOpen("label", "b77d79cb-4935-4f38-a9bc-a838c188fa23", hoisted6)
        text("Model Description")
      elementClose("label")
      elementOpen("textarea", "19f3ab54-ecf0-4d46-8c9d-4bdbe61e89fe", hoisted7, "value", model.description, "onchange", function ($event) {
        var $element = this;
      model.description = this.value})
      elementClose("textarea")
    elementClose("div")
    elementOpen("button", "21657573-c741-452f-ba7c-a6c9704485f6", hoisted8, "onclick", function ($event) {
      var $element = this;
    root.currentItem = model.addSchema()})
      elementOpen("i", "c92b099f-3824-49d3-a2ef-78da3b6d3a56", hoisted9)
      elementClose("i")
      text(" \
            Add schema to [" + ( model.name ) + "] \
          ")
    elementClose("button")
  elementClose("form")
}
